"use strict";
/**
 * Copyright (c) 2017-present, BlockCollider developers, All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var _createForOfIteratorHelper = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function isHexString(val) {
  if (val.startsWith('0x')) {
    val = val.slice(2);
  }

  if (!val) {
    return false;
  }

  var validHexChars = new Set('0123456789abcdefABCDEF'.split(''));

  var _iterator = _createForOfIteratorHelper(val),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var char = _step.value;

      if (!validHexChars.has(char)) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return true;
}

exports.isHexString = isHexString;

function normalizeHexString(hexStr) {
  if (!isHexString(hexStr)) {
    throw new Error("".concat(hexStr, " is not a valid hex string"));
  }

  var result = hexStr.toLowerCase();

  if (!result.startsWith('0x')) {
    result = "0x".concat(result);
  }

  return result;
}

exports.normalizeHexString = normalizeHexString;